import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowLeft, CalendarDays } from "lucide-react";
import { Section } from "../components/ui-kit";
import { fmtDate } from "./NewsList";
import { setPageMeta } from "../seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function NewsDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/news/${id}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [id]);

  useEffect(() => {
    if (post) {
      setPageMeta({
        title: `${post.title} | News | Spire Inclusion`,
        description: post.body.length > 155 ? post.body.slice(0, 155).trimEnd() + "…" : post.body,
        path: `/news/${id}`,
      });
    }
  }, [post, id]);

  if (notFound) {
    return (
      <Section tone="white">
        <div className="max-w-3xl mx-auto text-center py-10">
          <h1 className="font-heading text-3xl font-bold text-stone-900">Post not found</h1>
          <p className="mt-3 text-lg text-stone-700">This news post may have been removed.</p>
          <Link to="/news" className="mt-6 inline-flex items-center gap-2 font-semibold text-orange-700">
            <ArrowLeft className="h-5 w-5" aria-hidden="true" /> Back to news
          </Link>
        </div>
      </Section>
    );
  }

  if (!post) {
    return (
      <Section tone="white">
        <div className="flex items-center gap-2 text-stone-600 py-10">
          <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" /> Loading…
        </div>
      </Section>
    );
  }

  return (
    <Section tone="white">
      <article className="max-w-3xl mx-auto" data-testid="news-article">
        <Link to="/news" className="inline-flex items-center gap-2 font-semibold text-orange-700 hover:text-orange-800">
          <ArrowLeft className="h-5 w-5" aria-hidden="true" /> Back to news
        </Link>
        <p className="mt-6 flex items-center gap-2 text-base text-stone-500">
          <CalendarDays className="h-5 w-5" aria-hidden="true" />
          {fmtDate(post.created_at)}
        </p>
        <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-stone-900">
          {post.title}
        </h1>
        {post.image_url && (
          <img
            src={`${BACKEND}${post.image_url}`}
            alt={`Photo for the news post: ${post.title}`}
            className="mt-8 w-full rounded-3xl border border-stone-200 object-cover"
          />
        )}
        <div className="mt-8 text-lg text-stone-700 leading-relaxed whitespace-pre-wrap">{post.body}</div>
      </article>
    </Section>
  );
}
